import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'

// importação de estilos do material design for bootstrapp
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

// Vee-validate para a validação de formulários
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  configure,
  setInteractionMode,
  localize
} from 'vee-validate'

import {
  required,
  email,
  digits,
  min,
  max,
  alpha,
  regex,
  /* eslint-disable */
  alpha_spaces
} from 'vee-validate/dist/rules'
import pt from 'vee-validate/dist/locale/pt_PT.json'

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

extend('email', email)
extend('required', required)
extend('digits', digits)
extend('min', min)
extend('max', max)
extend('alpha', alpha)
extend('regex', regex)
/* eslint-disable */
extend('alpha_spaces', alpha_spaces)
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})

setInteractionMode('eager')

localize('pt_PT', pt)

// Axios global
Vue.prototype.$http = Axios

// uso do vue bus para comunicação simples entre componentes
export const bus = new Vue()

Vue.config.productionTip = false

const req = require.context('./boot', true, /\.js$/)
req.keys().forEach(filename => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line
    console.log(`[Bootloader]: loaded ${filename}`)
  }
  return req(filename)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
